import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { ClaimKeys } from 'src/app/helpers/claimkeys.class';
let LocalStorageService = class LocalStorageService {
    constructor() {
        this.claimKeys = new ClaimKeys();
    }
    set(name, item) {
        localStorage.setItem(name, JSON.stringify(item));
    }
    get(name) {
        return JSON.parse(localStorage.getItem(name));
    }
    remove(name) {
        localStorage.removeItem(name);
    }
    checkClaim(claim) {
        return this.get('ussr').Claims.includes(claim); //true;
    }
    getUserClaims() {
        return JSON.parse(localStorage.getItem('Claim') || '[]');
    }
};
LocalStorageService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], LocalStorageService);
export { LocalStorageService };
//# sourceMappingURL=local-storage.service.js.map